/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  FormControl,
  Textarea,
  FormErrorMessage,
} from '@wegroup/design-system';
import ResizeTextarea from 'react-textarea-autosize';
import React from 'react';
import { FieldError } from 'react-hook-form';
import { prefilledInputComponentStyling } from '../../../../constants/InputComponentStyling';
import { Inputs } from '../../../../types/Enums';
import { getFlowsDataTestId } from '../../../../utils/testUtils';

interface Props {
  onChange: (e: any) => void;
  error?: FieldError;
  name: string;
  onBlur: (e: any) => void;
  value: string;
  prefilled?: boolean;
  placeholder?: string;
  isDisabled?: boolean;
}

const MultiLineInput: React.FC<React.PropsWithChildren<Props>> = ({
  error,
  name,
  value,
  onChange,
  prefilled,
  onBlur,
  placeholder,
  isDisabled,
}) => {
  return (
    <FormControl isInvalid={!!error}>
      <Textarea
        name={name}
        value={value}
        onChange={onChange}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onBlur={(e: any) => onBlur(e)}
        bg="white"
        variant="flows"
        placeholder={placeholder}
        data-test-id={getFlowsDataTestId(Inputs.MULTILINE, name)}
        height="initial"
        as={ResizeTextarea}
        {...(prefilled && {
          sx: { ...prefilledInputComponentStyling },
        })}
        isDisabled={isDisabled}
      />
      {error && (
        <FormErrorMessage justifyContent="flex-end">
          {error?.message}
        </FormErrorMessage>
      )}
    </FormControl>
  );
};

export default MultiLineInput;
